// extracted by mini-css-extract-plugin
export default {"containerMobile":"style_containerMobile__SpQWJ","container":"style_container__yfBKz","single":"style_single__yt-g9","multiple":"style_multiple__qOybc"};